
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Support from '@/extend/classes/Support';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeSupport' })

export default class storeSupport extends VuexModule {
  // States
  private reccords: Support[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get supportLoading (): boolean {
    return this.dataLoading;
  }
  private get supportRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get supportLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewSupport() {
    return (): Support => { 
      return this.getSupport(0, true);
    }
  }

  
  public get getSupport () {
    return (id: number, canCreate = false): Support => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Support can't be 0")
        return new Support();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Support();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Support.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromSupport(data.reccords[0] as Support);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listSupport (): Support[] {
    return this.reccords;
  }

  public get listConfigSupport (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mSupportRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mSupportClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mSupportLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mSupportLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Support.fromJson(reccord as Support));
    })
    Support.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mSupportConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mSupportCreated (obj: Support): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSupport(obj)) {
          api.fromSupport(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareSupport(obj)) {
            api.fromSupport(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mSupportUpdated (obj: Support): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareSupport(obj)) {
          api.fromSupport(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mSupportDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerSupport (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.supportRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerSupport(this.supportCreated, this.supportUpdated, this.supportDeleted);
          this.mSupportRegistered();
        } else {
          setTimeout(() => resolve(this.registerSupport(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.supportLoading && !this.supportLoaded) {
          this.mSupportLoading(true);
          return Support.list(filter)
            .then((data: ListData) => {
              this.mSupportLoaded(data);
              this.mSupportLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredSupport (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.supportLoading) {
        this.mSupportLoading(true);
        return Support.list(filter)
          .then((data: ListData) => {
            this.mSupportLoaded(data);
            this.mSupportLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createSupport (obj: Support): Promise<Support> {
    return new Promise((resolve, reject) => {
      return Support.fromJson(obj).createForStoreSupport()
        .then((reccords) => {
          this.mSupportCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateSupport (obj: Support): Promise<Support> {
    return new Promise((resolve, reject) => {
      return Support.fromJson(obj).updateForStoreSupport()
        .then((reccords) => {
          this.mSupportUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteSupport (obj: Support): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Support.fromJson(obj).deleteForStoreSupport()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mSupportDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private supportCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSupportConfigUpdated(config)
    const obj = objConfig.obj as Support;
    this.mSupportCreated(Support.fromJson(obj));
  }

  @Action
  private supportUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mSupportConfigUpdated(config)
    const obj = objConfig.obj as Support;
    this.mSupportUpdated(Support.fromJson(obj));
  }

  @Action
  private supportDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Support;
    this.mSupportDeleted(obj.id);
  }
}
